import { useState } from 'react'
import { Button } from '@nazka/nazka.mapframe.components'
import { useNavigate } from 'react-router-dom'

import SharePopup from '@App/components/SharePopup/SharePopup';
import ImageWithFallback from '@App/components/ImageWithFallback/ImageWithFallback';

import { getImageUrl, getPlaceholderImageUrl } from '@services/utils.service';
import { useTranslation } from '@utils/i18n/i18n.consumers';
import { trackEvent } from '@services/analytics.service';

import './adaptation-story-action-card.styl'

function AdaptationStoryActionCard({ data, selectedData }) {
  const [showSharePopup, setShowSharePopup] = useState(false);
  const { t } = useTranslation()

  const navigate = useNavigate();

  return (
    <div className={`adaptation-story-action-card ${selectedData === data?.id ? 'adaptation-story-action-card--selected' : ''}`}>
      <ImageWithFallback
        className="adaptation-story-action-card__img"
        src={getImageUrl(data)}
        fallbackSrc={getPlaceholderImageUrl(data)}
        alt=""
      />
      <div className="adaptation-story-action-card__header">
        <span className="adaptation-story-action-card__header__title" title={data?.translations?.en?.title}>
          {data?.translations?.en?.title}
        </span>
        <span className={`adaptation-story-action-card__header__category ${data?.category === 'Story' ? 'adaptation-story-action-card__header__category--story' : 'adaptation-story-action-card__header__category--plan'}`}>
          {t(data?.category)}
        </span>
      </div>
      <p className="adaptation-story-action-card__description" title={data?.translations?.en?.description}>
        {data?.translations?.en?.description}
      </p>
      <div className="adaptation-story-action-card__footer my-third-adaptation-step">
        <Button
          css={{
            color: 'white',
            borderRadius: '10px',
            '&:hover': {
              color: 'white',
            },
          }}
          onClick={() => {
            trackEvent(`open_${data?.category.toLowerCase()}`);
            navigate(`/adaptation/${data?.category === 'Story' ? 'stories' : 'plans'}/${data?.id}`);
          }}
        >
          {t('See more')}
        </Button>
        <Button
          layout="outlined"
          css={{
            borderRadius: '10px',
            '&:hover': {
              color: 'white',
              backgroundColor: '#72A276',
            },
          }}
          onClick={() => {
            trackEvent(`share_${data?.category.toLowerCase()}`);
            setShowSharePopup(`${window.location.origin}/adaptation/${data?.category === 'Story' ? 'stories' : 'plans'}/${data?.id}`);
          }}
        >
          {t('Share')}
        </Button>
      </div>
      {showSharePopup && (
        <SharePopup
          qrCodeText={showSharePopup}
          onClose={() => setShowSharePopup(false)}
        />
      )}
    </div>
  )
}

export default AdaptationStoryActionCard